import { useState } from 'react';
import { Box, Paper, Typography, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Checkbox, Alert, Grid, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import AddCustomerModal from './AddCustomerModal';
import { updateClients } from '../../services/adminApiClient';

export default function CustomersTab({ customers, onUpdate }) {
    const [countryCode, setCountryCode] = useState('US'); // NEW
    const [selected, setSelected] = useState([]);
    const [isAddModalOpen, setAddModalOpen] = useState(false);
    const [actionStatus, setActionStatus] = useState({ type: '', text: '' });

    const filteredCustomers = customers.filter(c => c.region === countryCode);

    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            setSelected(filteredCustomers.map((n) => n.ClientCode));
            return;
        }
        setSelected([]);
    };

    const handleClick = (event, clientCode) => {
        const selectedIndex = selected.indexOf(clientCode);
        let newSelected = [];
        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, clientCode);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
        }
        setSelected(newSelected);
    };

    const isSelected = (clientCode) => selected.indexOf(clientCode) !== -1;

    const handleDelete = async () => {
        if (selected.length === 0) return;
        if (window.confirm(`Are you sure you want to delete ${selected.length} customer(s)?`)) {
            const customersToDelete = filteredCustomers.filter(c => selected.includes(c.ClientCode));
            const payload = customersToDelete.map(c => ({
                ClientName: c.ClientName,
                ClientCode: c.ClientCode,
                CountryCode: countryCode, // ✅ Include countryCode
                option: 'delete'
            }));
            try {
                await updateClients(payload);
                setActionStatus({ type: 'success', text: 'Customers deleted successfully!' });
                setSelected([]);
                onUpdate();
            } catch (e) {
                setActionStatus({ type: 'error', text: e.message || 'Failed to delete customers.' });
            }
        }
    };

    const handleAddSubmit = async (newCustomer) => {
        const payload = [{
            ClientName: newCustomer.clientName,
            ClientCode: newCustomer.clientCode,
            CountryCode: countryCode, // ✅ Include countryCode
            option: 'add'
        }];
        try {
            await updateClients(payload);
            setActionStatus({ type: 'success', text: 'Customer added successfully!' });
            setAddModalOpen(false);
            onUpdate();
        } catch (e) {
           throw e;
        }
    };

    const handleCountryChange = (event) => {
        setCountryCode(event.target.value);
        setSelected([]);
    };

    return (
        <Paper sx={{ p: 2 }}>
            {actionStatus.text && <Alert severity={actionStatus.type} sx={{ mb: 2 }}>{actionStatus.text}</Alert>}
            
            {/* Country Selector */}
            <Grid container spacing={2} sx={{ mb: 2 }}>
                <Grid item xs={12} md={3}>
                    <FormControl fullWidth>
                        <InputLabel>COUNTRY</InputLabel>
                        <Select value={countryCode} label="COUNTRY" onChange={handleCountryChange}>
                            <MenuItem value="US">US</MenuItem>
                            <MenuItem value="CA">CA</MenuItem>
                        </Select>
                    </FormControl>
                </Grid>
            </Grid>

            <TableContainer>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell padding="checkbox">
                                <Checkbox
                                    indeterminate={selected.length > 0 && selected.length < filteredCustomers.length}
                                    checked={filteredCustomers.length > 0 && selected.length === filteredCustomers.length}
                                    onChange={handleSelectAllClick}
                                />
                            </TableCell>
                            <TableCell sx={{ fontWeight: 'bold' }}>Client Name</TableCell>
                            <TableCell sx={{ fontWeight: 'bold' }}>Client Code</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {filteredCustomers.map((row) => {
                            const isItemSelected = isSelected(row.ClientCode);
                            return (
                                <TableRow
                                    key={row.ClientCode}
                                    hover
                                    onClick={(event) => handleClick(event, row.ClientCode)}
                                    role="checkbox"
                                    aria-checked={isItemSelected}
                                    selected={isItemSelected}
                                >
                                    <TableCell padding="checkbox">
                                        <Checkbox checked={isItemSelected} />
                                    </TableCell>
                                    <TableCell>{row.ClientName}</TableCell>
                                    <TableCell>{row.ClientCode}</TableCell>
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </TableContainer>

            <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, p: 2 }}>
                <Button variant="outlined" onClick={() => setAddModalOpen(true)}>Add New</Button>
                <Button variant="contained" color="error" onClick={handleDelete} disabled={selected.length === 0}>Delete</Button>
            </Box>

            <AddCustomerModal
                open={isAddModalOpen}
                onClose={() => setAddModalOpen(false)}
                onSubmit={handleAddSubmit}
            />
        </Paper>
    );
}
